// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"Ei","footerTopLinks":"Fi","footerFeedback":"Gi","footerSocial":"Hi","footerLegalLinks":"Ii","footerIconCards":"Ji","footerBotCopy":"Ki","screenReadersOnly":"Li"};